import { useContext, useMemo } from 'react'
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext'

export const useMatchVideos = (match_true) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { video_info } = sportsSeason_state ?? {}
  const { videoUrls } = video_info ?? {}

  const matchUrl = useMemo(() => {
    const _videoUrl = videoUrls?.[match_true?._itemKey]
    if (_videoUrl?.url) {
      return _videoUrl.url
    }
    return null
  }, [match_true?._itemKey])

  return (
    { matchUrl }
  )
}
